

<template>
<!-- 신청내역 상세보기 팝업 -->
<div class="modal fade" id="student_selet" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div>
                    <p class="bold dp-inblock h-30px font-23 mb-30">신청내역 상세보기</p>
                    <a class="pointer float-right layer-close ml-30" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                        <img src="../../assets/img/close.png" alt="close" class="close-btn">
                    </a>
                    <div class="apply-fieldset">
                        <div class="apply-program-wrap">
                            <div class="apply-select-number">
                                선택한 과정 <span class="txt-red">(1)</span>
                            </div>
                            <div class="apply-program-select">
                                <ul>
                                    <!-- 선택 했을 경우 -->
                                    <li class="program-select blue">
                                        <div class="apply-program-unit">
                                            <ul>
                                                <li>
                                                    <p>
                                                        <span>과목 <b class="bold">{{subject_name}}</b></span>
                                                    </p>
                                                    <p>
                                                        <span>스케쥴 <b class="bold">{{subject_start_time}} ~ {{subject_end_time}}</b></span>
                                                    </p>
                                                </li>
                                                <li>
                                                    <p>
                                                        <span>교육비 <b class="bold">{{edu_price}}원</b></span>
                                                    </p>
                                                    <p>
                                                        <span>교재비 <b class="bold">{{book_price}}원</b></span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="hq-table-row">
                            <h3>신청자 정보</h3>
                            <table>
                                <colgroup>
                                    <col width="30%">
                                    <col width="70%">
                                </colgroup>
                                <tbody>
                                    <!-- <tr v-for="(item, index) of info" :key="index">
                                        <th>{{item.item_name}}</th>
                                        <td>{{item.value}}</td>
                                    </tr> -->

                                    <tr v-for="(item, index) of info" :key="index">
                                        <th v-if="item.item_name !== '비밀번호' && item.valid">
                                            <span v-if="item.item_name.includes('E-mail')">
                                                E-mail
                                            </span>
                                            <span v-else>
                                                {{item.item_name}}
                                            </span>
                                            </th>
                                        <td v-if="item.item_name !== '비밀번호' && item.valid">{{item.value}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="hq-table-row">
                            <h3>결제 정보</h3>
                            <table>
                                <colgroup>
                                    <col width="30%">
                                    <col width="70%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>결제금액</th>
                                        <td>{{totalPrice}}원</td>
                                    </tr>
                                    <tr>
                                        <th>결제방법</th>
                                        <td>
                                            {{formatPayWay(pay_way)}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div
                    @click="initPassword"
                    class="txt-right pointer">
                    <p class="admin-btn-default btn ml-05">비밀번호 초기화</p>
                </div>
                
            </div>
            <div class="modal-footer txt-center">
                <a href="" class="admin-btn-default btn ml-05">확인</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {

    props:{
        parentIdx:{
            type:Number,
            require: true,
            default:0
        },
        parentName:{
            type:String,
            default:""
        },
        idxItmSugangStudent:{
            type:Number,
            require: true,
        }
    },
    watch: {
        parentIdx: function (newVal) {
            console.log("watch",newVal);
           this.getDetail();
        }
    },  
    data: () => ({
        class_name: '', // 과정명
        subject_name: '', // 과목명
        subject_start_time: '', // 수업 시작시간
        subject_end_time: '', // 수업 종료시간
        edu_price: '', // 교육비
        book_price: '', // 교재비

        info: '',

        status: '', // 신청자정보
        pay_status: '', // 결제정보

        name: '', // 이름
        email: '', // email
        number: '', // 사번
        mobile: '',
        position: '',

        totalPrice: '', // 총 결제 금액 
        pay_way: '', // C 카드, A 계좌이체
        update_date: '' // 결제일
    }),

    mounted() {
       this.getDetail();
    },

    methods: {
        getDetail(){
             this.name = this.parentName
        var studentSubjectIdx = this.parentIdx
        let idxItmSugangStudent = this.idxItmSugangStudent
        var params = {
            studentSubjectIdx: studentSubjectIdx
        }
        this.axios.get(this.axios.root + this.axios.port + `/admin/student-detail/${idxItmSugangStudent}/${studentSubjectIdx}`)
            .then(res => {
                if (res.data.err === 0) {
                    this.info = res.data.info
                    this.class_name = res.data.userDetail.class_name
                    this.subject_name = res.data.userDetail.subject_name
                    this.subject_start_time = res.data.userDetail.subject_start_time
                    this.subject_end_time = res.data.userDetail.subject_end_time

                    this.edu_price = res.data.userDetail.edu_price
                    this.book_price = res.data.userDetail.book_price
                    this.totalPrice = this.edu_price + this.book_price

                    this.status = res.data.userDetail.status
                    this.pay_status = res.data.userDetail.pay_status
                    this.email = res.data.userDetail.email
                    this.number = res.data.userDetail.number
                    this.mobile = res.data.userDetail.mobile
                    this.position = res.data.userDetail.position
                    this.pay_way = res.data.userDetail.pay_way
                    this.update_date = res.data.userDetail.update_date

                    for (var item of this.info) {
                        if (item.item_name === '이름') {
                            item['valid'] = true
                            item['value'] = this.name
                        } else if (item.item_name.includes('E-mail@')) {
                            item['value'] = this.email
                            item['valid'] = true
                        } else if (item.item_name === '사번') {
                            item['valid'] = true
                            item['value'] = this.number
                        } else if (item.item_name === '휴대전화번호') {
                            item['valid'] = true
                            item['value'] = this.mobile
                        } else if (item.item_name === '직급') {
                            item['valid'] = true
                            item['value'] = this.position
                        } else {

                        }
                    }
                } else {
                    alert(res.data.result)
                }
            }).catch(err => {
                console.log(err)
                alert(err)
            })
        },
        // 결제방법에 따른 한글 변환
        formatPayWay(status) {
            switch (status) {
                case 'C':
                    return '카드'
                case 'A':
                    return '계좌이체'
                default:
                    return '-'
            }
        },

        initPassword(){
            if(confirm('비밀번호를 초기화 하시겠습니까?')){
                this.axios.put(this.axios.root + this.axios.port + `/admin/user/password`, {
                    idxItmSugangStudent: this.idxItmSugangStudent
                })
            .then(res => {
                console.log(res)
                if(res.data.success){
                    alert('비밀번호 초기화 완료')
                }else{
                    alert(res.data.result)
                }
            })
            .catch(err => { 
                    console.log(err)
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}

.apply-fieldset {
    width: 400px;
    margin: 0 auto;
    padding: 20px 0;
    border-top: 2px solid #aaa;
}

.apply-fieldset .down-btn-tl button {
    padding: 8px 15px;
    text-align: center;
    display: inline-block;
    font-size: 14px;
    vertical-align: middle;
    background: #fff;
    border: 1px solid #cccccc;
    color: #000000;
    border-radius: 0;
    letter-spacing: -0.5px;
}

.apply-fieldset .down-btn-tr {
    text-align: right;
}

.apply-fieldset .down-btn-tr button {
    padding: 8px 15px;
    text-align: center;
    display: inline-block;
    font-size: 14px;
    vertical-align: middle;
    background: #fff;
    border: 1px solid #cccccc;
    color: #000000;
    border-radius: 0;
    letter-spacing: -0.5px;
}

.apply-fieldset .down-btn-bl button {
    padding: 8px 15px;
    text-align: center;
    display: inline-block;
    font-size: 14px;
    vertical-align: middle;
    background: #fff;
    border: 1px solid #cccccc;
    color: #000000;
    border-radius: 0;
    letter-spacing: -0.5px;
}

.apply-fieldset .down-btn-br {
    text-align: right;
}

.apply-fieldset .down-btn-br button {
    padding: 8px 15px;
    text-align: center;
    display: inline-block;
    font-size: 14px;
    vertical-align: middle;
    background: #fff;
    border: 1px solid #cccccc;
    color: #000000;
    border-radius: 0;
    letter-spacing: -0.5px;
}

.apply-fieldset .mail-form {
    width: 300px;
}

.apply-fieldset .call-form {
    width: 80px;
}

.apply-fieldset .apply-program-wrap {
    width: 100%;
}

.apply-fieldset .apply-program-wrap .apply-select-number {
    font-size: 16px;
}

.apply-fieldset .apply-program-wrap .apply-select-number button {
    border: 1px solid #ddd;
    background: #fff;
    padding: 10px 20px;
    display: inline-block;
    float: right;
    margin-top: -10px;
}

.apply-fieldset .apply-program-wrap .apply-program-select {
    width: 100%;
    margin-bottom: 5px;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li {
    border-radius: 15px;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li.program-info {
    margin-top: 20px;
    border: 2px solid #ddd;
    background: #fff;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li.program-select {
    margin-top: 20px;
    background: #fff;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li.program-select.blue {
    border: 2px solid #0066b0;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li.program-select.red {
    border: 2px solid #db3738;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li.program-select.green {
    border: 2px solid #39a170;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit {
    width: 95%;
    margin: 0 auto;
    display: block;
    padding: 20px 0px;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li.unit-title {
    font-size: 22px;
    padding: 0 0 10px 0;
    text-decoration: underline;
    cursor: pointer;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li.unit-title h4 {
    display: inline;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li.unit-title img {
    width: 17px;
    float: right;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li.unit-title.blue {
    color: #0066b0;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li.unit-title.red {
    color: #db3738;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li.unit-title.green {
    color: #39a170;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li p {
    display: inline-block;
    padding: 3px 0 0 0;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li p span {
    display: inline-block;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li p span::after {
    content: '';
    height: 15px;
    width: 1px;
    vertical-align: middle;
    background: #999;
    display: inline-block;
    margin: 0 12px 0 16px;
}

.apply-fieldset .apply-program-wrap .apply-program-select ul li .apply-program-unit li p:nth-child(2) span::after {
    background: none;
}
</style>

